import * as React from "react";

import styles from "./RadioField.module.scss";

export interface RadioFieldProps {
  value: string;
  master: { [key: string]: string };
  onChange: (args: string) => void;
}
export const RadioField = (props: RadioFieldProps) => {
  const [state, setState] = React.useState(props.value);
  return (
    <div className={styles.radioArea}>
      {Object.keys(props.master).map(key => (
        <label className={styles.selectBtn} key={key}>
          <input
            type="radio"
            value={key}
            onChange={() => {
              setState(key);
              props.onChange(key);
            }}
            checked={state === key}
          />
          <span>{props.master[key]}</span>
        </label>
      ))}
    </div>
  );
};

export default RadioField;
